import {
  gql,
  createVanillaApolloClient,
  createVanillaUtils,
} from '@material-bank/apollo-client';
import { VanillaApolloUtils } from '@material-bank/apollo-client/vanilla';

const PROJECT_FRAGMENT = gql`
  fragment ProjectFragment on Project {
    id
    title
    country {
      code
    }
    state {
      code
    }
    city
    createdAt
    updatedAt
    externalId
    status
    userRef
    phase {
      code
      label
    }
    details
    type {
      code
      label
      externalId
    }
    budget {
      from
      to
      unit
    }
    size {
      from
      to
      unit
    }
    dueMonth
    dueYear
  }
`;

const GET_PROJECTS = gql`
  query ProjectsQuery(
    $statuses: [ProjectStatus!]
    $excludedStatuses: [ProjectStatus!]
    $page: Int
    $pageSize: Int
    $sortBy: ProjectSortableField
    $sortDirection: SortDirection
  ) {
    projects(
      statuses: $statuses
      excludedStatuses: $excludedStatuses
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        ...ProjectFragment
      }
      currentPage
    }
  }
  ${PROJECT_FRAGMENT}
`;

let cachedClient: VanillaApolloUtils | null = null;

const getClient = async () => {
  if (cachedClient) {
    return cachedClient;
  }
  const client = await createVanillaApolloClient({
    enableSubscriptions: true,
    enableAuth: true,
  });

  cachedClient = createVanillaUtils(client);
  return cachedClient;
};

export const getProjects = async () => {
  const client = await getClient();
  return client.query(GET_PROJECTS);
};
